// Layout.js
import React from 'react';
import { Outlet } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import { Navigation } from './Navigation';

function Layout({ onLogout }) {

  return <>
    <div className='outer-wrapper outer-header'>
      <Container>
        <Row className='header'>
         <Navigation onLogout={onLogout} />
       </Row>
      </Container>
    </div>
    <div className='outer-wrapper outer-content'>
      <Outlet/>
    </div>
    <div className='outer-wrapper outer-footer'>
      <Container>
        <Row className='footer'>
          <p>Version: {process.env.REACT_APP_VERSION}</p>
        </Row>
      </Container>
    </div>
  </>
}

export default Layout;
